define('modules/form_editor/views/preview_custom_gender',['require','exports','module','./preview_group_base','./preview_custom_gender_item','ldsh!../templates/preview_custom_gender'],function(require, exports, module){
  "use strict";
  var PreviewGroupBase = require("./preview_group_base"),
      PreviewCustomGenderItem = require("./preview_custom_gender_item");
  module.exports = PreviewGroupBase.extend({
    itemView: PreviewCustomGenderItem,
    itemContainer: "select",
    template: require("ldsh!../templates/preview_custom_gender")
  });
});

